<template>
  <div class="page-login">
    <header>
      <div class="content">
        <a href="/"><img src="/images/logo.svg" class="header-logo" /></a>
        <a href="/login" class="header-button-si">Sign In</a>
      </div>
    </header>
    <section class="login">
      <div class="content">
        <div class="login-form">
          <h1>{{trans('passwords.reset_password')}}</h1>
          <div v-if="!showMessage">
          <form class="form-horizontal form-material" id="resetForm" @submit.prevent="submit" @keydown="resetForm.errors.clear($event.target.name)">
            <label for="email">Email</label>
            <input type="text" name="email" v-model="resetForm.email">
            <show-error :form-name="resetForm" prop-name="email"></show-error>

            <label for="password">Password</label>
            <input type="password" name="password" v-model="resetForm.password">
            <show-error :form-name="resetForm" prop-name="password"></show-error>

            <label for="password">{{ trans('auth.confirm_password') }}</label>
            <input type="password" name="password" v-model="resetForm.password_confirmation">
            <show-error :form-name="resetForm" prop-name="password_confirmation"></show-error>

            <!--  <h3>or sign in with</h3>
             <ul class="login-social">
               <li class="icon-linkedin"><input type="radio" name="social" id="social-linkedin" /><label for="social-linkedin">LinkedIn</label></li>
               <li class="icon-google"><input type="radio" name="social" id="social-google" /><label for="social-google">Google</label></li>
               <li class="icon-microsoft"><input type="radio" name="social" id="social-microsoft" /><label for="social-microsoft">Microsoft</label></li>
             </ul> -->
            <button class="button" style="margin-top:30px;">{{trans('passwords.reset_password')}}</button>
          </form>
          </div>
            <div v-else class="text-center">
              <h4 v-text="message" class="alert alert-success" v-if="status"></h4>
              <h4 v-text="message" class="alert alert-danger" v-else></h4>
            </div>
        </div>
        <div class="login-hiw">
          <h2>Here’s how it works</h2>
          <ul>
            <li><i>1</i><h3>Complete our first questionnaire</h3><p>Tell us more about your investor preferences and your investment offering</p></li>
            <li><i>2</i><h3>Get some free, suitable investor insights</h3><p>based on the information submitted</p></li>
            <li><i>3</i><h3>Book a video call with one of our experts</h3><p>Our team will review your offering and give you a quote</p></li>
          </ul>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
    </section>
  </div>
</template>

<script>
import guestFooter from '../../layouts/guest-footer.vue'

export default {
  data() {
    return {
      resetForm: new Form ({
        email: '',
        password: '',
        password_confirmation: '',
        token:this.$route.params.token,
      }),
      message: '',
      status: true,
      showMessage: false
    }
  },
  components: {
    guestFooter
  },
  mounted(){
    axios.post('/api/auth/validate-password-reset',{
      token: this.resetForm.token
    }).then(response => {
      this.showMessage = false;
    }).catch(error => {
      this.message = helper.fetchDataErrorMsg(error);
      this.showMessage = true;
      this.status = false;
    });
  },
  methods: {
    submit(e){
      this.resetForm.post('/api/auth/reset').then(response =>  {
        this.message = response.message;
        this.showMessage = true;
        this.status = true;
      }).catch(error => {
        helper.showErrorMsg(error);
      });
    }
  }
}
</script>